export function isValidGallery({ children }: TContent): boolean {
  return children.some((elem) => elem.type === 'core__image');
}
